import ClubsEnum from '@/achieve/enums/annual-recognition/clubs.enum';
import AnnualRecognitionMember from '@/achieve/entities/annual-recognition/annual-recognition-member.entity';
import BackofficeServicesRepository from '@/_shared/repositories/backoffice-services.repository';

class AnnualRecognitionService {
  private servicesRepository: BackofficeServicesRepository = new BackofficeServicesRepository();

  public getClubMembers(club: ClubsEnum): Promise<AnnualRecognitionMember[]> {
    return this.servicesRepository.get(`/distributors/clubs/${club}`, { withCredentials: true })
      .then(({ data }) => data.members.map((item: any) => new AnnualRecognitionMember(item)));
  }
}

export default new AnnualRecognitionService();
